import React, { Component } from "react"
import PropTypes from "prop-types"
import { cx } from "ramda-extension"

import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import styles from "./styles.less"

class SelectList extends Component {
  static propTypes = {
    collection: PropTypes.array.isRequired,
    selected: PropTypes.any.isRequired,
    onChange: PropTypes.func,
    icon: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      selected: props.selected,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selected: nextProps.selected || [],
    })
  }

  handleSelect(item, event) {
    if (item.id === this.state.selected) return
    this.props.onChange && this.props.onChange(item.id)
    this.setState({
      selected: item.id,
    })
  }

  render() {
    const { collection } = this.props

    return (
      <div>
        {collection.map((o) => (
          <div
            key={o.id}
            className={cx(styles.item, {
              [styles.itemSelected]: o.id === this.state.selected,
            })}
            onClick={(event) => this.handleSelect(o, event)}>
            {o.icon && <Icon className={styles.icon} icon={o.icon} />}
            <span className={styles.title}>{o.title}</span>
          </div>
        ))}
      </div>
    )
  }
}

export default SelectList
